// extracted by mini-css-extract-plugin
module.exports = {"active":"RadioButton_active__lCDko","inactive":"RadioButton_inactive__MurlA"};